module.exports = __webpack_public_path__ + "media/images/add-receipt-42ba1dbf5ee728c88b65fae76db118d6.svg";